module.exports = __webpack_public_path__ + "bx-analyse";